import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "workOrder-admin",
  "use": "workOrder-admin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"workOrder-admin\"><defs><style>#workOrder-admin .cls-1{fill:none}</style></defs><title>Group 94</title><g id=\"workOrder-admin_图层_2\" data-name=\"图层 2\"><g id=\"workOrder-admin_图层_1-2\" data-name=\"图层 1\"><g id=\"workOrder-admin_Group_94\" data-name=\"Group 94\"><path id=\"workOrder-admin_Rectangle_37_Copy_23\" data-name=\"Rectangle 37 Copy 23\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"workOrder-admin_filetext\"><path id=\"workOrder-admin_Shape\" d=\"M6 22.51A1.5 1.5 0 0 1 4.5 21V3A1.49 1.49 0 0 1 6 1.5h7.08a1.53 1.53 0 0 1 .6.12h.06a1.76 1.76 0 0 1 .3.24l5.7 5.75a1.49 1.49 0 0 1 .42 1V21a1.48 1.48 0 0 1-1.46 1.48zM6 21h12.76V9.38h-4.9a1.5 1.5 0 0 1-1.5-1.48V3H6zm1.89-2.3a.74.74 0 0 1 0-1.48h6.56a.74.74 0 0 1 0 1.48zm0-3.29a.74.74 0 0 1-.77-.71.73.73 0 0 1 .69-.7h9.25a.74.74 0 1 1 .05 1.47H7.87zm0-3.28a.74.74 0 0 1-.77-.71.73.73 0 0 1 .71-.76h5.31a.74.74 0 1 1 .05 1.47H7.87z\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/workOrder-admin.svg
// module id = bKx1
// module chunks = 6